import { Icon, type SupportedIcon } from 'corso-admin-ui';

export function DataTableStatus({
  title,
  details,
  icon,
  action,
}: {
  title: string;
  details?: string;
  icon: SupportedIcon;
  action?: { label: string; onClick: () => void };
}) {
  return (
    <section className="flex flex-col items-center justify-center gap-3 rounded-md border border-neutral-200 bg-white p-8 text-sm">
      <Icon icon={icon} className="size-10 text-neutral-500" />
      <h2 className="text-base font-semibold text-neutral-900">{title}</h2>
      {details && (
        <p className="max-w-prose text-center text-neutral-600">{details}</p>
      )}
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="text-sm font-medium text-corso-blue-600 hover:underline"
        >
          {action.label}
        </button>
      )}
    </section>
  );
}
